import { IconProps } from "typing";
import { theme } from "../themes";

export const MyCardsIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
  testId = "my-cards-icon",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      data-testid={testId}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00065 13.333H4.16732C3.01672 13.333 2.08398 12.4003 2.08398 11.2497V5.41634C2.08398 4.26575 3.01672 3.33301 4.16732 3.33301H13.334C14.4846 3.33301 15.4173 4.26575 15.4173 5.41634V6.66634"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5.41602"
        y="6.66699"
        width="12.5"
        height="10"
        rx="2.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41602 9.99967H17.916"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0007 13.3337H8.33398"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
